"use strict";

var _toConsumableArray = require("/vercel/workpath0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var BN = require("bn.js");

var buffer_1 = require("buffer");

function deepEqual(a, b) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var depth = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
  options = Object.assign({
    maxDepth: 5
  }, options);
  var result = false;

  if (depth <= options.maxDepth) {
    if (a === b) {
      result = true;
    } else {
      var aType = typeof a;
      var bType = typeof b;

      if (aType === bType && !!a === !!b && aType === "object") {
        if (BN.isBN(a) && BN.isBN(b)) {
          result = a.eq(b);
        } else if (buffer_1.Buffer.isBuffer(a) && buffer_1.Buffer.isBuffer(b)) {
          result = a.equals(b);
        } else if (Array.isArray(a) && Array.isArray(b)) {
          var aLength = a.length;
          var bLength = b.length;

          if (aLength === bLength) {
            result = a.every(function (value, index) {
              return deepEqual(value, b[index], options, depth + 1);
            });
          }
        } else {
          var aKeys = Object.keys(a);
          var bKeys = Object.keys(b);

          var keys = _toConsumableArray(new Set([].concat(_toConsumableArray(aKeys), _toConsumableArray(bKeys))));

          if (aKeys.length === keys.length && bKeys.length === keys.length) {
            result = keys.every(function (key) {
              return deepEqual(a[key], b[key], options, depth + 1);
            });
          }
        }
      }
    }
  }

  return result;
}

exports.deepEqual = deepEqual;